import script from "./OrgAdminPage.vue?vue&type=script&setup=true&lang=js"
export * from "./OrgAdminPage.vue?vue&type=script&setup=true&lang=js"

import "./OrgAdminPage.vue?vue&type=style&index=0&id=1ed1066b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1ed1066b"]])

export default __exports__